import { createFileRoute } from "@tanstack/react-router";
import { PlatformAuditLogListPage } from "@client/components/admin/audit-logs/platform-audit-log-list-page";

export const Route = createFileRoute("/_app/settings/audit-logs/")({
  component: SettingsAuditLogs,
});

function SettingsAuditLogs() {
  return <PlatformAuditLogListPage />;
}
